abstract class Page {

	protected systemName: string = 'Page';

	protected constructor(name: string) {
		this.systemName = name;

		console.log(name, 'Base Page Constructor');
	}

	public init() {
		this.prepareView();

		this.msg('view init done');
	}

	protected msg(msg: string) {
		console.log(this.systemName, msg);
	}

	protected errorMsg(msg: string) {
		console.error(this.systemName, msg);
	}

	prepareView() {
		this.startup();
		this.bind();
	}

	abstract startup(): void;
	abstract bind(): void;
}

export default Page;